import { Box, Button, Typography } from "@mui/material";

export function Retry({ message, onRetry }) {
  return (
    <Box
      sx={{
        wordBreak: "break-word",
        padding: "20px 24px",
        borderRadius: "12px",
        background: "#FFF3EB",
        color: "#1A2025",
        border: "1px solid rgba(218, 87, 0, 1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
        {message}
      </Typography>
      <Button
        sx={{
          background: "#FFDCC5",
          color: "#DA5700",
          padding: "12px 20px",
          borderRadius: "29px",
        }}
        onClick={onRetry}
      >
        Retry
      </Button>
    </Box>
  );
}
